import { ChangeEvent } from 'react';
import { Checkbox } from 'components/UI';

type ParameterCheckboxProps = {
  name: string;
  value: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const ParameterCheckbox = ({ name, value, onChange }: ParameterCheckboxProps) => (
  <Checkbox name={name} isChecked={!!value} onChange={onChange} maxW={2.5} />
);

export default ParameterCheckbox;
